// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"dafdc4ca","438":"b8f950dd","486":"7b5300e5","521":"25e008a6","659":"506e03c0","746":"528f4a2f","755":"b1ad01fa"}[chunkId] + ".chunk.js";
};